<template>
    <div>
        <div v-if="!innerIsReview">
            <validation-provider
                v-slot="{ errors }"
                :name="label || 'This'"
                :rules="rules"
                v-bind="providerProps"
                v-show="innerShouldShow"
                :vid="'validate-' + fieldAssignmentId"
                ><span v-if="label" v-html="label"></span>
                <span
                    class="field-directions"
                    v-if="directions"
                    v-html="directions"
                ></span>
                <div v-if="attributes && attributes.length > 0">
                    <v-row v-for="(attr, i) in attributes" :key="i" dense>
                        <v-col cols="12">
                            <type-money
                                v-model="attr.retail_price"
                                v-bind="[computedProps]"
                                :validation_settings="{ required: true }"
                                :mode="'new'"
                                :type="'Money'"
                                :label="`${attr.name} ${attr.pivot && attr.pivot.sub_title || ''}`"
                                @change="signalChange"
                                :fieldAssignmentId="
                                    fieldAssignmentId + '-' + i + '-1'
                                "
                            ></type-money>
                        </v-col>
                    </v-row>
                </div>
                <div v-else>
                    <span
                        >No price tiers created.</span
                    >
                </div>
            </validation-provider>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="attributes && attributes.length">
                    <v-row dense>
                        <v-col cols="12" md="3">
                            <label>Tier</label>
                        </v-col>
                        <v-col cols="12" md="4">
                            <label>Age Range</label>
                        </v-col>
                        <v-col cols="12" md="4">
                            <label>Price</label>
                        </v-col>
                        <v-col cols="12" md="1"></v-col>
                    </v-row>
                    <v-row
                        v-for="(attr, i) in attributes || []"
                        :key="'attribute-' + i"
                    >
                        <v-col cols="12" md="3">{{ attr.name }}</v-col>
                        <v-col cols="12" md="4">{{ attr.sub_title }}</v-col>
                        <v-col cols="12" md="4">${{ attr.retail_price }}</v-col>
                    </v-row>
                </div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin';
import TypeReview from './TypeReview';
import TypeTextBox from './TypeTextBox';
import TypeMoney from './TypeMoney';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'TypeAttributesVenue',
    mixins: [formMixin],
    components: {
        TypeReview,
        TypeTextBox,
        TypeMoney
    },
    data() {
        return {
            attributes: [],
            campaignId: null
        };
    },
    async mounted() {
        // await this.getAttributes();
        this.fieldLoaded(); // signal to the form we are loaded
        this.loadRoute(this.$route);
    },
    computed: {
        ...mapState('venue', ['venueCampaignData']),
        defaults() {
            return {
                label: this.innerLabel,
                persistentHint: true,
                venueId: null,
                campaignId: null
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {};
        },
        computedProps() {
            return { ...this.componentProps, outlined: true, persistentPlaceholder: false };
        }
    },
    methods: {
        ...mapActions('venue', ['getVenueCampaignById']),
        async loadRoute(route) {
            this.venueId = route.params.venueId;
             this.campaignId = route.query.campaignId;
            // get deals price tiers
             if (this.campaignId) {
                this.getVenueCampaignById({
                    venueId: this.venueId,
                    campaignId: this.campaignId
                }).then(() => {
                     if (this.innerValue && this.innerValue.length)
                        this.attributes = this.innerValue
                    else
                        this.attributes = this.venueCampaignData.deal.r_attributes;
                        this.attributes.forEach(el => {
                            // the id causes an update conflict. 
                            // This is really the attribute id, not the product_attribute id
                            // we will copy over the appropriately labeled attribute_id from the pivot later on
                            delete el.id  
                        });
                });
            }
        },
        signalChange() {
            const tempAttrs = []
            this.attributes.forEach(el => {
                tempAttrs.push({...el, ...el.pivot})
            })

            this.innerValue = tempAttrs

             // this.innerValue = [...this.attributes, ...this.attributes.pivot];

             this.$emit('input', this.innerValue);
        }
    }
};
</script>
